import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgcCommonModule } from '../common.module';
// This Module's Components
import { DateSelectionComponent } from './date-selection.component';

@NgModule({
  imports: [NgcCommonModule, ReactiveFormsModule, FormsModule, CommonModule],
  declarations: [DateSelectionComponent],
  exports: [DateSelectionComponent]
})
export class DateSelectionModule {}
